<template>
  <div class="admin_membership">
    <div style="width:100%;">
      <b-container class="form fluid">
        <b-card class="text-center" style="background:rgba(255,255,255,.9);">
          <h5>Admin Membership</h5>

          <hr style="margin-bottom:50px;">

          <div class="container" style="background:rgba(255,255,255,.9); padding:20px 0;">
            <searchMember v-on:memberSelected="memberSelected($event)"></searchMember>
          </div>

          <div v-if="selectedMember.id" class="container" style="background:rgba(255,255,255,.9); padding:20px 0; margin-top:20px;">
            <div class="mx-auto" style="text-align:center; max-width:700px">
              <span class="m-3"><b-button variant="link" @click="getMemberHistory(selectedMember.id)">History</b-button></span>
              <span class="m-3">MEMBER INFO</span>
            </div>

            <div class="row m-3" style="text-align:left">
              <div class="col-sm-4">
                <div>
                  <span class="info_title">Name</span>
                  <span class="info_body">{{ selectedMember.first_name }} {{ selectedMember.last_name }}</span><br>
                </div>
                <div>
                  <span class="info_title">Email</span>
                  <span class="info_body">{{ selectedMember.email }}</span><br>
                </div>
                <div>
                  <span class="info_title">Phone</span>
                  <span class="info_body">{{ selectedMember.phone }}</span><br>
                </div>
                <div>
                  <span class="info_title">City</span>
                  <span class="info_body">{{ selectedMember.city }}</span><br>
                </div>
              </div>

              <div class="col-sm-4">
                <div>
                  <span class="info_title">Member ID</span>
                  <span class="info_body">{{ selectedMember.id }}</span><br>
                </div>
                <div>
                  <span class="info_title">Member Type</span>
                  <span class="info_body">{{ memberTypeLabel(selectedMember.paid_member_type) }}</span><br>
                </div>
                <div>
                  <span class="info_title">Current Expiration</span>
                  <span class="info_body">{{ selectedMember.member_expires || 'None' }}</span><br>
                </div>
                <div>
                  <span class="info_title">Free Passes</span>
                  <span class="info_body">{{ selectedMember.free_pass }}</span><br>
                </div>
                <div>
                  <span class="info_title">Code #</span>
                  <span class="info_body">{{ selectedMember.member_code }}</span><br>
                </div>
              </div>

              <div class="col-sm-4" style="text-align:center;">
                <img v-if="selectedMember.photo" :src="selectedMember.photo" style="max-width:220px; width:90%;" />
              </div>
            </div>

            <div style="max-width:700px; margin:auto; text-align:left;">
              <hr>
              <label style="width:100%;">
                Membership Expiration
                <b-form-datepicker
                  v-model="selectedMember.editable_member_expires"
                  today-button
                  reset-button
                  locale="en-US"
                  :date-format-options="{month: 'short', day: 'numeric', year: 'numeric'}"
                ></b-form-datepicker>
              </label>

              <div style="text-align:center; margin-top:20px;">
                <b-button variant="outline-secondary" style="margin:3px" :disabled="selectedMember.saving" @click="adjustMembership(-1)">
                  -1 Month
                </b-button>
                <b-button variant="outline-primary" style="margin:3px" :disabled="selectedMember.saving" @click="adjustMembership(1)">
                  +1 Month
                </b-button>
                <b-button variant="success" style="margin:3px" :disabled="selectedMember.saving" @click="saveMembershipExpiration">
                  Save Date
                </b-button>
              </div>
            </div>
          </div>
        </b-card>
      </b-container>
    </div>

    <b-modal ref="modal-member-history" hide-footer size="lg" title="History">
      <memberHistory :member_id=selectedMemberId :limit=25></memberHistory>
    </b-modal>
  </div>
</template>

<script>
import datetime_mixin from '../../mixins/datetime.js'
import memberHistory from '../reusable/member_history.vue';
import searchMember from '../staff/member_search.vue';

export default {
  mixins: [datetime_mixin],
  components: {
    memberHistory,
    searchMember,
  },
  data() {
    return {
      selectedMember: {},
      selectedMemberId: 0,
    }
  },
  methods:{
    normalizeMemberExpires(memberExpires) {
      return memberExpires ? memberExpires.split("T")[0] : ''
    },
    memberTypeLabel(paidMemberType) {
      if (paidMemberType == 1) return 'GOLD Pass'
      if (paidMemberType == 2) return 'STANDARD Pass'
      return 'None'
    },
    memberSelected(member) {
      member.member_expires = this.normalizeMemberExpires(member.member_expires)
      member.editable_member_expires = member.member_expires
      member.saving = false
      this.selectedMember = member
    },
    updateSelectedExpiration(memberExpires) {
      this.selectedMember.member_expires = memberExpires
      this.selectedMember.editable_member_expires = memberExpires
    },
    saveMembershipExpiration() {
      if (!this.selectedMember.editable_member_expires) {
        alert("Membership expiration can't be empty")
        return
      }

      this.selectedMember.saving = true
      this.$http.post('/api/admin/membership_expiration',
        {
          id : parseInt(this.selectedMember.id),
          member_expires : this.selectedMember.editable_member_expires,
        }
      ).then((resp) => {
        this.updateSelectedExpiration(resp.data.member_expires)
      }).catch((error) => {
        alert(error.response.data.message);
        console.log(error.response.data.message);
        console.log(error.response.status);
        console.log(error.response.headers);
      }).finally(() => {
        this.selectedMember.saving = false
      })
    },
    adjustMembership(months) {
      this.selectedMember.saving = true
      this.$http.post('/api/admin/membership_expiration_month',
        {
          id : parseInt(this.selectedMember.id),
          months : months,
        }
      ).then((resp) => {
        this.updateSelectedExpiration(resp.data.member_expires)
      }).catch((error) => {
        alert(error.response.data.message);
        console.log(error.response.data.message);
        console.log(error.response.status);
        console.log(error.response.headers);
      }).finally(() => {
        this.selectedMember.saving = false
      })
    },
    getMemberHistory(id){
      if (id<=0) return;

      this.selectedMemberId = +id
      this.$refs['modal-member-history'].show()
    },
  }
}
</script>

<style scoped lang="scss">
* {
  font-family: 'Montserrat';
  box-sizing: border-box;
  color: #8b8c8d;
}
.info_title {
  display: inline-block;
  width: 145px;
  font-size: .85em;
  font-weight: bold;
  padding: 6px 0;
}
.info_body {
  font-size: .95em;
}
</style>
